import Vue from "vue";
import i18n from "@/i18n";
import store from "@/store";
import { PAGES } from "@/enums/pages";
import router from "@/router";

export const digitalSignatureCall = async () => {
    store.commit("SpinnerModule/setLoading", true, { root: true });
    const response = await store.dispatch("ProposalsModule/proposalDigitalSignature");
    if (response?.response) {
        const { status } = response?.response;
        Vue.$toast.open({
            message: status !== 200 ? i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.digitalSignatureError") : i18n.t("pages.SimulatorPage.simulationError.toProposalSuccess.digitalSignatureSuccess"),
            dismissible: true,
            type: "error",
        });

        if (status === 200) {
            Vue.$toast.open({
                message: i18n.t("pages.SimulatorPage.simulationError.toProposalSuccess.digitalSignatureSuccess"),
                dismissible: true,
                type: "success",
            });
            router.push({ name: PAGES.PROPOSAL_LIST_PROPOSAL });
        }
    } else {
        Vue.$toast.open({
            message: i18n.t("pages.SimulatorPage.simulationError.toProposalSuccess.digitalSignatureSuccess"),
            dismissible: true,
            type: "success",
        });
        router.push({ name: PAGES.PROPOSAL_LIST_PROPOSAL });
    }
    store.commit("SpinnerModule/setLoading", false, { root: true });
};